import React, { useState } from "react"
import styled from "styled-components"
import Menu from "./menu"

const Nav = styled.nav`
    z-index: 1000;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.8);
    position: absolute;
    background: ${props => props.theme.background};
    width: 100%;
    overflow-x: ${props => (props.hideOverflow ? "hidden" : "visible")};
    @media screen and (min-width: 768px) {
        position: fixed;
        height: 3.5rem;
    }
`

const Logo = styled.a`
    img {
        width: 7rem;
        padding: 0.5rem;
        padding-left: 1rem;
        @media screen and (min-width: 768px) {
            width: 10.5rem;
        }
    }
`

export default function Header({ data, images }) {
    const [showMenu, setShowMenu] = useState(false)
    const [hideOverflow, setHideOverflow] = useState(true)

    function handleClick(e) {
        //Shows nav overflow only if menu open, delays hiding it until animation completes
        e.preventDefault()
        if (showMenu) {
            setShowMenu(false)
            setTimeout(() => {
                setHideOverflow(true)
            }, 500)
        } else {
            setShowMenu(true)
            setHideOverflow(false)
        }
    }

    return (
        <Nav hideOverflow={hideOverflow}>
            <Logo href="https://tuffshed.com" target="_blank">
                <img alt="Tuff Shed Logo" src={images[data.image].fixed.src} />
            </Logo>
            <Hamburger handleClick={handleClick} />
            <Menu
                data={data}
                isOpen={showMenu}
                closeMenu={handleClick}
                images={images}
            />
        </Nav>
    )
}

const HamburgerBar = styled.div`
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background: ${props => props.theme.text};
`

const HamburgerContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 1.75rem;
    height: 1rem;
    cursor: pointer;
    padding: 0.65rem 1rem;
    border-left: 0.5px solid ${props => props.theme.lightGrey};
`

function Hamburger({ handleClick }) {
    return (
        <HamburgerContainer onClick={handleClick}>
            <HamburgerBar />
            <HamburgerBar />
            <HamburgerBar />
        </HamburgerContainer>
    )
}
